import PropTypes from "prop-types";

import CustomerBalanceDetails from "./CustomerBalanceDetails";
import CreditTable from "./CreditTable";
import LedgerTable from "./LedgerTable";

import { selectedCustomerPropTypes } from "./propTypes";

const LedgerDetails = ({ selectedCustomer, ledgerType }) => {
  return (
    <>
      <CustomerBalanceDetails
        selectedCustomer={selectedCustomer}
        ledgerType={ledgerType}
      />
      <CreditTable
        selectedCustomer={selectedCustomer}
        ledgerType={ledgerType}
      />
      <LedgerTable
        selectedCustomer={selectedCustomer}
        ledgerType={ledgerType}
      />
    </>
  );
};

export default LedgerDetails;

LedgerDetails.propTypes = {
  selectedCustomer: PropTypes.shape(selectedCustomerPropTypes).isRequired,
  ledgerType: PropTypes.string,
};
